import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const Table = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop:'1rem',
  marginBottom:'1rem',
  border:'1px solid rgba(34,36,38,.15)',
  overflowY:'hidden',
  overflowX:'scroll',
  width: '98.5%',
  paddingBottom:'1rem',
  fontSize:'11px',

  '*':{
    boxSizing:'border-box'
  },

  'input, textarea, select, button':{
    fontSize:'11px !important'
  },

  'input, textarea':{
    width:'100% !important',
    maxWidth:'100% !important',
    minWidth:'0 !important'
  },

  '.fieldInput, .fieldRow, .ui.input, .ui.input input, .ui.form textarea':{
    width:'100% !important',
    maxWidth:'100% !important',
    minWidth:'0 !important'
  },

  '.selected':{
    background:'rgba(173,220,145,.15) !important',

    'div .textSelected':{
      fontWeight:'bold'
    },

    'textarea, div.fieldInput textarea:disabled':{
      background:'rgba(173,220,145,.0) !important',
    },
    'input, div.fieldInput input:disabled':{
      background:'rgba(173,220,145,.0) !important',
    }
  },

  '.header1':{
    display:'flex',

    '.header1sec1':{
      minWidth:'350px !important',
      maxWidth:'100% !important',
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      textAlign: 'center',
      flexDirection:'column',
      flex:1
    },

    '.header1sec2':{
      display:'flex',
      flexDirection:'column',
      alignItems:'center',
      textAlign: 'center',
      minWidth:'17.5rem',
      maxWidth:'17.5rem',
      fontSize: '11px'
    },
    
    '>div':{
      fontWeight:'bold',
      background:' rgba(0,0,0,0.03)',
      borderRight:'1px solid rgba(34,36,38,.15)',
      borderBottom:'1px solid rgba(34,36,38,.15)',
    }
  },

  '.header2':{
    display:'flex',
    height:'3rem',

    '.header2sec1':{
      fontWeight:'bold',
      display:'flex',
      flex:1,
      justifyContent:'center',
      alignItems:'center',
      maxWidth:'100% !important',
      minWidth:'350px !important',
      borderRight:'1px solid rgba(34,36,38,.15)',
      borderBottom:'1px solid rgba(34,36,38,.15)',

      '>div':{
        display:'flex',
        justifyContent:'center',
        // paddingLeft:'0.1rem',
        // flex:1,
        height:'100%',
        alignItems:'center',
        borderRight:'1px solid rgba(34,36,38,.15)'
      },

      '>div:last-child':{
        borderRight:'none'
      }
    },

    '.header2sec2':{
      fontWeight:'bold',
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      minWidth:'17.5rem',
      maxWidth:'17.5rem',
      borderRight:'1px solid rgba(34,36,38,.15)',
      borderBottom:'1px solid rgba(34,36,38,.15)',

      '>div':{
        display:'flex',
        flexDirection:'column',
        height:'100%',
        alignItems:'center',
        justifyContent:'center',
        flex:'0 0 50%',
        maxWidth:'50% !important',
        minHeight:'0',
        minWidth:'0',
        padding:'0.1rem',
        lineHeight:'1.15',
        textAlign:'center',
        overflowWrap:'anywhere',
        borderRight:'1px solid rgba(34,36,38,.15)'
      },

      '>div span':{
        marginLeft:'0 !important'
      },

      '>div:last-child':{
        borderRight:'none'
      }
    }
  },

  '.row':{
    display:'flex',
    lineHeight:'2rem',

    '.rowsec1':{
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      maxWidth:'100% !important',
      minWidth:'350px !important',
      flex:1,
      borderRight:'1px solid rgba(34,36,38,.15)',
      borderBottom:'1px solid rgba(34,36,38,.15)',
      
      '.colPRRef':{
        cursor:'pointer',
        textDecoration: 'underline',
        color: '#FBBF66'
      },

      '.colPRRef:hover':{
        color:'#000',
        fontWeight:'bold'
      },

      '.number':{
        display: 'flex',
        justifyContent: 'flex-end',
      },

      '.center':{
        display:'flex',
        justifyContent:'center'
      },

      '>div':{
        // flex:1,
        // paddingLeft:'0.1rem',
        borderRight:'1px solid rgba(34,36,38,.15)',
        height: '100% !important',
        wordWrap: 'anywhere !important',
      },

      '>div:last-child':{
        borderRight:'none'
      }
    },

    '.rowsec2':{
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      minWidth:'17.5rem',
      maxWidth:'17.5rem',
      borderRight:'1px solid rgba(34,36,38,.15)',
      borderBottom:'1px solid rgba(34,36,38,.15)',

      '.number':{
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight:'0.4rem'
      },

      '>div':{
        maxWidth:'50% !important',
        minWidth:'50% !important',
        paddingLeft: '0.1rem',
        borderRight:'1px solid rgba(34,36,38,.15)',
        height: '100% !important'
      },

      '>div:last-child':{
        borderRight:'none'
      }
    }
  },
  
  '.rowField':{
    display:'flex',
    lineHeight:'3rem',
    
    '.last':{
      borderBottom:'1px solid rgba(34,36,38,.15) !important'
    },

    '.error':{
      marginLeft:'0 !important'
    },

    '>.rowFieldTitle':{
      flex:1,
      minWidth:'350px !important',
      maxWidth:'100% !important',
      display:'flex',
      fontWeight:'bold',
      paddingRight:'0.5rem',
      borderBottom:'none'
    },

    '>.rowFieldInput':{
      display:'flex',
      minWidth:'17.5rem',
      maxWidth:'17.5rem',
    },

    '>div .vatRate':{
      display:'flex',
      alignItems:'center',
      minWidth:'30%',
      alignItems:'center',
      justifyContent:'flex-end',
      borderRight:'1px solid rgba(34,36,38,.15)',

      '>div':{
        marginLeft:'0.5rem',
        maxWidth:'50% !important'
      }
    },

    '>div':{
      display:'flex',
      justifyContent:'flex-end',
      alignItems:'center',
      borderRight:'1px solid rgba(34,36,38,.15)',
      borderBottom:'1px solid rgba(34,36,38,.15)',

      '.number':{
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight:'0.4rem'
      },

      '.btn':{
        flex:1,
        display: 'flex',
        justifyContent: 'center',
      },

      '>div':{
        borderRight:'1px solid rgba(34,36,38,.15)'
      },

      '>div:last-child':{
        borderRight:'none'
      }
    },

    '>.discount':{
      '>div':{
        marginRight:'0 !important',
        padding:'0.2rem !important',
      },

      'div.fieldRow':{
        marginBottom:'0 !important'
      },

      'input':{
        paddingRight:'0.2rem'
      }
    },

    'div .rowFieldArea':{
      flex:1,
      padding:'0.2rem !important',

      '>div':{
        marginRight:'0 !important'
      },

      'div .fieldRow':{
        marginBottom:'0 !important'
      },

      'textarea': {
        resize: 'none'
      }
    },

    'div .rowFieldFile':{
      flex:1,
      alignSelf:'flex-start',
      padding:'0.2rem !important',
      maxWidth:'100%',

      '.oldFile':{
        '.fileUploadCellContainer':{
          background: '#8EDD65 !important',
          border: 'none !important',
        }
      },

      'button':{
        maxWidth:'100%',
        width:'100%'
      },

      '>div':{
        marginRight:'0 !important'
      },

      'div .fieldRow':{
        marginBottom:'0 !important'
      },

      '.fileUploadCellContainer':{
        lineHeight:'2rem !important'
      },

      '.dropArea .buttonUI':{
        width: '100% !important',
        fontSize:'1rem !important',
        minWidth:'100% !important'
      },
  
      '.fileInput':{
        minWidth:'auto',
        width:'100% !important'
      },
  
      '.dropzone':{
        marginTop:'0rem !important',
      },
      
      '.dropArea':{
        padding:'0rem !important'
      },
  
      '.textTitle':{
        fontSize:'1rem !important',
        lineHeight:'1.4rem !important'
      },

      '.fileSizeContent':{
        display:'none !important'
      },

      '.fileNameContent':{
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth:'100%',
        fontSize: '11px'
      }
    },
  },

  '@media only screen and (min-width: 600px)': {
    '.header1':{
      '.header1sec1':{
        minWidth:'40% !important',
      }
    },

    '.header2':{
      '.header2ec1':{
        minWidth:'40% !important',
      }
    },

    '.row':{
      '.rowsec1':{
        minWidth:'40% !important',
      }
    },

    '.rowField':{
      '>.rowFieldTitle':{
        minWidth:'40% !important',
      }
    }
  },

  '@media only screen and (min-width: 769px)': {
    '.header1':{
      '.header1sec1':{
        minWidth:'40% !important',
      }
    },

    '.header2':{
      '.header2sec1':{
        minWidth:'40% !important',
      }
    },

    '.row':{
      '.rowsec1':{
        minWidth:'40% !important',
      }
    },

    '.rowField':{
      '>.rowFieldTitle':{
        minWidth:'40% !important',
      }
    }
  }
})

export const TablePage = styled.div({
  display:'flex',
  alignItems:'center',
  alignSelf:'flex-start',
  '>div':{
    marginRight:0,
    'div':{
      marginBottom:'0px !important'
    }
  }
})

export const HH = styled.div({
  flex:1,
  display:'flex',
  alignItems:'center',
})
